import SoleEvents from '@client/ClientEvents/SoleEvents.jsx';
import Plus24Events from '@client/ClientEvents/Plus24Events.jsx';
import Plus24PayEvents from '@client/ClientEvents/Plus24PayEvents.jsx';

export { SoleEvents, Plus24Events, Plus24PayEvents };
